export default __webpack_public_path__ + "static/media/crude-graph.da10e8aa.svg";